import React, { useState } from "react";
import axios from "axios";
import {
  Col,
  FormGroup,
  Input,
  Label,
  Card,
  CardHeader,
  CardBody,
  Button
} from "reactstrap";
import PartnerInfoForm from "./PartnerInfoForm";
import Alert from "../../Widgets/Alert";
import withAlertTimeout from "../../../HOCs/withAlertTimeout";

const CreatePartner = props => {
  const [isSubmitting, setIsSubmitting] = useState(false);

  const onPartnerCreated = () => {
    props.showSuccess();
  };

  const onSubmit = async payload => {
    const token = sessionStorage.getItem("token");
    const headers = { Authorization: `Bearer ${token}` };

    try {
      setIsSubmitting(true);

      const { data } = await axios.post("/api/proxy/v2/partneradmin", payload, {
        headers
      });
      onPartnerCreated();
    } catch (e) {
      props.showFailure();
      console.log(e);
    } finally {
      setIsSubmitting(false);
    }
  };

  return (
    <Card>
      {<Alert active={props.success} message="Partner Created" />}
      {
        <Alert
          type="danger"
          active={props.failure}
          message="Something went wrong, please try again"
        />
      }
      <CardHeader>Create Partner</CardHeader>
      <CardBody>
        <Col md="6" xs="12">
          <PartnerInfoForm isSubmitting={isSubmitting} onSubmit={onSubmit} />
        </Col>
      </CardBody>
    </Card>
  );
};

export default withAlertTimeout(CreatePartner);



// WEBPACK FOOTER //
// ./src/views/Pages/Partnership/CreatePartner.js